import { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { MainArea } from './components/MainArea';
import { useTheme } from './lib/theme';
import { useRealtime } from './lib/realtime';

export function App() {
  // Первичная инициализация темы (само применит class к <html>)
  useTheme();
  // Realtime invalidations между вкладками одного workspace
  useRealtime();
  const [activeNodeId, setActiveNodeId] = useState<string | null>(null);

  return (
    <div className="h-screen flex bg-canvas-light dark:bg-canvas-dark text-ink-light dark:text-ink-dark">
      <Sidebar activeNodeId={activeNodeId} onActivate={setActiveNodeId} />
      <MainArea activeNodeId={activeNodeId} onActivate={setActiveNodeId} />
    </div>
  );
}
